<template>
  <main class="complete-main">
    <div class="complete-container">
      <h1><img class="logo" src="@/assets/img/login_logo.svg" alt="ディーモ for 社労士" /></h1>
      <div class="message-content">
        <div class="header">
          <p class="title">認証URLが無効です</p>
        </div>

        <div class="content-message">
          メール認証URLの有効期限が切れているか、
          <br />
          URLが無効です。
          <br />
          新しいアカウント登録を行うか、
          <br />
          既にアカウントをお持ちの場合はログインしてください。
        </div>

        <div class="action-buttons">
          <button class="input-submit" @click="goToLogin">ログインへ</button>
          <button class="input-submit secondary" @click="goToJoin">新規登録へ</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
  import { useRouter } from 'vue-router'

  const router = useRouter()

  // ログイン画面へ移動
  const goToLogin = () => {
    router.push('/login')
  }

  // 新規登録画面へ移動
  const goToJoin = () => {
    router.push('/join')
  }
</script>

<style lang="less" scoped>
  .complete-main {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f5f5;
    color: var(--text-color);
  }

  .complete-container {
    margin: auto;
    width: 100%;
    max-width: 600px;
    background-color: #fff;
    border-radius: 10px;
    padding: 50px 35px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);

    h1 {
      text-align: center;
      margin-bottom: 2rem;

      .logo {
        width: 100%;
        max-width: 200px;
        height: auto;
      }
    }
  }

  .message-content {
    width: 100%;
    max-width: 600px;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    text-align: center;
  }

  .header {
    margin-bottom: 30px;
  }

  .title {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 20px 0;
  }

  .content-message {
    font-size: 14px;
    margin-bottom: 30px;
    text-align: center;
    line-height: 1.6;
    color: #333;
  }

  .action-buttons {
    width: 80%;
    margin: 0 auto;
    margin-top: 20px;

    .input-submit {
      &.secondary {
        background-color: #6b7280;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
</style>
